import { gql } from '@apollo/client';
import { useMutation } from '@tbitop/api';
import { useGraphQLErrorHandler } from '@tbitop/error-handling';
import { useCallback } from 'react';
import type { PartnerWechselnMutation, PartnerWechselnMutationVariables } from './__generated__/PartnerWechselnMutation';

export const usePartnerWechselnMutation = () => {
  const { handleWithErrorNotification } = useGraphQLErrorHandler();
  const [executeMutation, { loading, error }] = useMutation<PartnerWechselnMutation, PartnerWechselnMutationVariables>(gql`
    mutation PartnerWechseln(
      $mandantenId: String!,
    ) {
      partnerWechseln(mandantenId: $mandantenId)
    }
  `,
  {
    onError: e => handleWithErrorNotification('Wechseln des Partners fehlgeschlagen.')(e),
  });

  return {
    execute: useCallback((variables: PartnerWechselnMutationVariables) => executeMutation({ variables }), [executeMutation]),
    loading,
    error,
  };
};
